import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { isMobile } from "react-device-detect";
import Hammer from 'hammerjs';
import ModeSwitcher from './containers/mode-switch/ModeSwitcher'
import Poster from './containers/poster/Poster'
import VideoPlayer from './containers/video-player/VideoPlayer'
import TextPlayer from './containers/text-player/TextPlayer'
import TopToolbar from './containers/top-toolbar/TopToolbar'
import PlayControls from './containers/play-controls/PlayControls';
import TextSettingsSidebar from './containers/text-mode-settings/TextModeSettings'
import NavigationGallery from './containers/navigation-gallery/NavigationGallery'
import LoginPopup from './containers/login-popup/LoginPopup';
import WidgetCarousel from './containers/widget-carousel/WidgetCarousel';
import WidgetChannel from './containers/widget-channel/WidgetChannel';
import AudioChapters from './containers/audio-chapters/AudioChapters';


import {
  showUnavailablePopup,
} from './store/actions';

import {
  widgetInit,
} from './store/actions/widget-actions';
import {
  showControls,
  defferedHiding,
  clearTimerOfHidding,
} from './store/actions/controls-visibility-actions';
import {
  nextPage,
  prevPage,
} from './store/actions/read-actions';
import {
  authorize
} from './store/actions/data-fetching-actions';

import {
  debounce,
} from './tools/utils'

import {
  getIsStarted,
  getUnavailablePopupVisibility,
  getIsAuthorized,
  getApiKey,
  getIsBookFetched,
  getIsBookFetching,
  getViewMode,
  getIsWidget,
  getIsWidgetChannel,
  getIsWidgetBooks,
  getControlsVisibility,
} from './store/selectors/selectors';

import ErrorComponent, { ERROR_TYPE } from "./components/error-layer-component/ErrorLayerComponent";
import './assets/cine-books-icons.css';
import SiteEvents from "./containers/event-dispatcher/SiteEvents";

class App extends Component {
  timerMouseOut = null;

  componentDidMount() {

    const {isAuthorized, authorize, initData} = this.props;

    if (!isAuthorized) {
      authorize(initData);
    }

    // if it's a widget - init extra parameters
    this.props.widgetInit(initData);

    // if it's a widget - we don't need to load a book
    let isWidgetChannel = initData.wgtC;
    if (isWidgetChannel) {
      return;
    }

    let guid = initData.guid;

    if (!guid || guid.length < 6) {
      console.warn("Missing book's guid or guid is invalid, given '" + guid + "'");
      this.props.showUnavailablePopup();
      return;
    }

    // let _this = this;

    this.hammer = new Hammer(document.querySelector('.cnb-player'));
    this.hammer.on("swipeleft", this.swipeLeft);
    this.hammer.on("swiperight", this.swipeRight);

  }

  componentWillUnmount() {
    this.hammer.off('swipeleft', this.swipeLeft);
    this.hammer.off('swiperight', this.swipeRight);
  }

  swipeLeft = () => {
    if (this.props.viewMode === 'text') {
      this.props.nextPage();
    }
  };

  swipeRight = () => {
    if (this.props.viewMode === 'text') {
      this.props.prevPage();
    }
  };


  hideControlsAfterCursorLeave = debounce((e) => {
    this.props.defferedHiding();
  }, 550);

  defferedHiding = debounce((e) => {
      this.props.defferedHiding();
  }, 500);

  handleOverlayTap = () => {
    this.props.showControls();
    this.props.defferedHiding();
  }

  handleOnMouseLeave = () => {
    if (this.props.isStarted === true && !isMobile) {
      this.hideControlsAfterCursorLeave()
    }
  }

  handleMouseMove = () => {
    if (this.props.isStarted === true && !isMobile) {
      this.props.clearTimerOfHidding();
      this.props.showControls();
      this.defferedHiding();
    }
  }

  handleAppTouchSrtart = () => {
    // reset timer
    if (!this.props.showTouchableOverlay) {
      this.props.clearTimerOfHidding();
    }
  }

  handleAppTouchEnd = () => {
    // start new timer
    if (!this.props.showTouchableOverlay) {
      this.defferedHiding();
    }
  }

  render() {
    const {
      viewMode,
      isWidget,
      isWidgetChannel,
      isStarted,
      isWidgetBooks
    } = this.props;

    return (
      <div
        className={cx(
          'cnb-player',
          `cnb-player-${viewMode}`,
          { 'cnb-player-mobile': isMobile }
        )}
        onMouseLeave={this.handleOnMouseLeave}
        onMouseMove={this.handleMouseMove}
        onTouchStart={this.handleAppTouchSrtart}
        onTouchEnd={this.handleAppTouchEnd}
      >
        <TopToolbar
          textSwipeLeft={this.swipeLeft}
          textSwipeRight={this.swipeRight}
        />
        <ModeSwitcher />
        <Poster/>
        <VideoPlayer />
        <TextPlayer />
        <PlayControls />
        <TextSettingsSidebar />
        <AudioChapters />
        <NavigationGallery />
        <SiteEvents />

        {this.props.showTouchableOverlay &&
          <div
            className="cnb-mobile-touchable-overlay"
            onTouchStart={this.handleOverlayTap}
          />
        }

        <LoginPopup />
        {isWidget && !isStarted && isWidgetBooks && <WidgetCarousel />}
        {isWidget && isWidgetChannel && <WidgetChannel />}

        {this.props.unavailablePopupShown &&
          <ErrorComponent type={ERROR_TYPE.UNAVAILABLE} />
        }

        {!this.props.apiKey && !this.props.unavailablePopupShown &&
          <ErrorComponent type={ERROR_TYPE.NOT_AUTHORIZED} />
        }

      </div>
    );
  };
}



const mapStateToProps = state => {
  const isStarted = getIsStarted(state);

  return {
    showTouchableOverlay: !getControlsVisibility(state) && isStarted && isMobile && getViewMode(state) !== 'text',
    isStarted,
    unavailablePopupShown: getUnavailablePopupVisibility(state),
    isAuthorized: getIsAuthorized(state),
    apiKey: getApiKey(state),
    isBookFetched: getIsBookFetched(state),
    isBookFetching: getIsBookFetching(state),
    viewMode: getViewMode(state),
    isWidget: getIsWidget(state),
    isWidgetChannel: getIsWidgetChannel(state),
    isWidgetBooks: getIsWidgetBooks(state),
  }
};

const actionCreators = {
  authorize,
  widgetInit,
  showUnavailablePopup,
  showControls,
  defferedHiding,
  clearTimerOfHidding,
  nextPage,
  prevPage,
};

export default connect(mapStateToProps, actionCreators)(App);


// WEBPACK FOOTER //
// ./src/App.jsx